import React from "react";
export function SiteFooter() {
  return <footer className="w-full bg-navy-deep px-5 pb-32 pt-14" data-id="element-365" data-mp="3rjw0bkxgv4kv">
      <div className="mx-auto max-w-3xl text-center" data-id="element-366" data-mp="1beait8cinkfg">
        <p className="font-serif text-2xl font-black text-white" data-id="element-367" data-mp="1bgwu9j2j2k2y">Interceptive Orthodontics Blueprint™</p>
        <p className="mt-1 text-sm font-semibold uppercase tracking-widest text-gold" data-id="element-368" data-mp="1kfrywqpxbm45">By Dr. Valeria Montes</p>
        <p className="mx-auto mt-4 max-w-xl text-white/75" data-id="element-369" data-mp="nprcuzgxvjqj">
          A structured educational reference system for dental professionals who want to study early
          orthodontic assessment, mixed dentition, interceptive treatment planning, and clinical monitoring.
        </p>
        <div className="mt-8 border-t border-white/10 pt-6 text-left" data-id="element-370" data-mp="wocqcg7k08kg">
          <p className="text-sm font-bold text-white/90" data-id="element-371" data-mp="11ih3jh7exctz">Professional Educational Disclaimer</p>
          <p className="mt-2 text-xs leading-relaxed text-white/65" data-id="element-372" data-mp="40z2d7lu2nch">
            This material is intended for professional education and reference purposes only. It does not
            replace formal orthodontic training, specialist consultation, evidence-based clinical guidelines,
            comprehensive patient-specific diagnosis, informed consent, or professional judgment. Treatment
            decisions must be made by appropriately qualified clinicians according to individual patient needs
            and applicable regulations.
          </p>
        </div>
        <p className="mt-8 text-xs text-white/60" data-id="element-373" data-mp="3o29w3v7hug8r">
          © 2026 · Dr. Valeria Montes · Interceptive Orthodontics Blueprint™ · All Rights Reserved.
        </p>
      </div>
    </footer>;
}